import * as React from 'react';
import { AscParticipateContainer } from '../../containers';

const AscParticipatePage: React.FC = () => (
  <AscParticipateContainer />
);

export default AscParticipatePage;
